module.exports = __webpack_public_path__ + "img/img-31.5d897f51.png";